import { PASSWORD_PATTERN } from '../patterns'

export const FORM_VALIDATION_RULES = {
    email: {
        required: {
            required: true,
            message: 'Please enter your email address',
        },
        format: {
            type: 'email',
            message: 'Please enter a valid email address.',
        },
        rules: [
            {
                required: true,
                message: 'Please enter your email address',
            },
            {
                type: 'email',
                message: 'Please enter a valid email address.',
            },
        ],
    },
    password: {
        required: {
            required: true,
            message: 'Please enter your password',
        },
        minLength8: {
            min: 8,
            message: 'Password must be at least 8 characters long',
        },
        includeUpperLowerNumber: {
            pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
            message:
                'Password must include at least one uppercase letter, one lowercase letter, and one number',
        },
        strong: {
            validator: async (_, value) => {
                if (value && !PASSWORD_PATTERN.test(value)) {
                    return Promise.reject(
                        new Error(
                            'Password must include at least one uppercase letter, one lowercase letter, and one number'
                        )
                    )
                }
                return Promise.resolve()
            },
        },
        strongWithMaxLength: {
            validator: async (_, value) => {
                if (!PASSWORD_PATTERN.test(value) && value?.length > 0) {
                    return Promise.reject(
                        new Error(
                            'Password must include at least one uppercase letter, one lowercase letter, and one number'
                        )
                    )
                }
                return Promise.resolve()
            },
        },
        confirm: (
            passwordField = 'password',
            requiredMessage = 'Please confirm password',
            mismatchMessage = 'Passwords do not match'
        ) => [
            {
                required: true,
                message: requiredMessage,
            },
            ({ getFieldValue }) => ({
                validator(_, value) {
                    if (!value || getFieldValue(passwordField) === value) {
                        return Promise.resolve()
                    }
                    return Promise.reject(new Error(mismatchMessage))
                },
            }),
        ],
    },
}
